import useTableIds from "@/Components/Tables/useTableIds";
import useCourierOrders from "@/shared/hooks/useCourierOrders";
import { useMemo } from "react";

const useSelectedOrders = () => {
  const [ids] = useTableIds();
  const { orders } = useCourierOrders();
  const selected = useMemo(
    () => orders.filter((o) => ids.includes(o.order_information.item_id)),
    [orders, ids]
  );

  return selected ?? [];
};

export default useSelectedOrders;
